import { SET_APP_ERROR_MESSAGE, RESET_APP_ERROR_MESSAGE } from "../types";

export default function appMessage(state = {}, action = {}) {
  switch (action.type) {
    case SET_APP_ERROR_MESSAGE: {
      return action.errorMessage;
    }
    case RESET_APP_ERROR_MESSAGE: {
      const newState = state;
      if (state.errorMessage) delete newState.errorMessage;
      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appMessage.js